// John Eldhose 20180625
import { RestfulPost } from './Restful';

export async function createProfile(data) {
  const prof = await RestfulPost('createProfile', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return prof;
}



// WEBPACK FOOTER //
// ./src/Api/createProfile.js